// extracted by mini-css-extract-plugin
export default {"app-spinner__svg":"de7cb4","rotator":"f150de","app-spinner__svg-path":"fe1fe2","dash":"d6e5e5","app-spinner--center":"f927d7"};